// extracted by mini-css-extract-plugin
module.exports = {"DraggableCard":"bff_a"};